(function () {
  try {
    if (sessionStorage.getItem('af_has_visited') === '1') {
      document.documentElement.classList.add('af-skip-splash');
      if (document.body) {
        document.body.classList.add('loaded');
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          document.body.classList.add('loaded');
        });
      }
    }
    sessionStorage.setItem('af_has_visited', '1');
  } catch (e) {
    /* sessionStorage blocked */
  }
})();
